import { useId, useState } from "react";

export function Input({
  label,
  required,
  error,
  hint,
  type = "text",
  ...props
}) {
  const id = useId();
  const [focus, setFocus] = useState(false);

  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 1.4,
            color: "var(--accent)",
            marginBottom: 6,
          }}
        >
          {label}
          {required && (
            <span style={{ color: "var(--gold)" }} aria-hidden="true">
              {" *"}
            </span>
          )}
          {required && <span className="sr-only"> (required)</span>}
        </label>
      )}
      <input
        id={id}
        type={type}
        aria-invalid={Boolean(error) || undefined}
        aria-describedby={hint ? id + "-hint" : undefined}
        required={required}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        {...props}
        style={{
          width: "100%",
          // --bg-input gives the field a slight lift against the page in dark
          // mode (where bg-elevated == bg) and falls back to the white card in
          // light mode. The placeholder + caret colours are inherited from
          // the global form baseline.
          background: "var(--bg-input)",
          border: `1.5px solid ${focus ? "var(--accent)" : "var(--border-strong)"}`,
          borderRadius: 14,
          padding: "13px 16px",
          minHeight: 44,
          fontSize: 14,
          color: "var(--text)",
          fontFamily: "var(--font-system)",
          transition: "border-color .2s, box-shadow .2s, background-color .2s",
          boxShadow: focus ? "0 0 0 3px rgba(196, 135, 154, 0.22)" : "none",
          ...(props.style || {}),
        }}
      />
      {hint && !error && (
        <div
          id={id + "-hint"}
          style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 6 }}
        >
          {hint}
        </div>
      )}
      {error && (
        <div
          role="alert"
          style={{ fontSize: 11, color: "#C02020", marginTop: 6, fontWeight: 600 }}
        >
          {error}
        </div>
      )}
    </div>
  );
}
